import { render, staticRenderFns } from "./UpdatePictureProfile.vue?vue&type=template&id=0d556c8a&"
import script from "./UpdatePictureProfile.vue?vue&type=script&lang=js&"
export * from "./UpdatePictureProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports